import { render, staticRenderFns } from "./TurfCircles.vue?vue&type=template&id=52ca8cca&scoped=true&"
import script from "./TurfCircles.vue?vue&type=script&lang=js&"
export * from "./TurfCircles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca8cca",
  null
  
)

export default component.exports